import { Injectable } from '@angular/core';
import { DataService } from '../common/data.service';
@Injectable({
  providedIn: 'root'
})
export class EmployeeRecoveryService {

  constructor(private _data: DataService) { }

  
  /*******************************Service Methods*************************************/
  AddEmployeeMaster = (data: any): any => {    
    return this._data.PostData('EmployeeRecovery/SaveEmployeeRecovery', data);
  }

  GetAllEmployeeRecoveryList = (data: any): any => {
    return this._data.PostData('EmployeeRecovery/GetAllEmployeeRecoveryList', data);
  }
  GetAllEmployeeRecoveryFinanceList = (data: any): any => {
    return this._data.PostData('EmployeeRecovery/GetAllEmployeeRecoveryFinanceList', data);
  }

  GetEmployeeRecoveryDataByID = (ID: string): any => {
    return this._data.GetDataById('EmployeeRecovery/GetEmployeeRecoveryByID', ID);
  }
  RecoveryExportData = (data: any): any => {
    return this._data.DownloadFileWithPost('EmployeeRecovery/ExportToExcel', data);
}

RecoveryExportFinanceData = (data: any): any => {
  return this._data.DownloadFileWithPost('EmployeeRecovery/EmployeeExportFinanceList', data);
}
EmployeeRecoveryDetails = (data: any): any => {
  return this._data.PostData('EmployeeRecovery/EmployeeRecoveryWaveOffDetails', data);
}
UploadClientResponseData = (data: any): any => {
  return this._data.postfile('EmployeeRecovery/AttachmentModel', data);
}
GetEmployeeRecoveryWaveOffDetailsByID=(ID:string):any=>{
  return this._data.GetDataById('EmployeeRecovery/GetEmployeeRecoveryWaveOffByID', ID);
}

GetAttachment = (data: any): any => {
  return this._data.DownloadFileWithPost('EmployeeRecovery/ShowAttachFile', data);
}

  /**********************************END*********************************************/
}
